module.exports = __webpack_public_path__ + "static/media/instagram.e5b61c71.svg";